import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function MidCtaSection() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 bg-warmBrown/30 border-y border-gold/20" data-id="element-175">
      <div className="max-w-2xl mx-auto text-center" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-6" data-id="element-177">
          <p className="text-sm font-semibold text-red-400 flex items-center justify-center gap-2" data-id="element-178">
            <span data-id="element-179">🔥</span> Acceso completo hoy por
          </p>
          <p className="text-5xl sm:text-6xl font-bold text-gold tracking-tight" data-id="element-180">
            $14.990 ARS
          </p>

          <motion.a href="https://lacocinaquevende.shop/cart/53378602205457:1" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="group relative inline-flex items-center justify-center gap-3 px-8 py-5 text-lg font-bold text-charcoal bg-gold hover:bg-gold-light rounded-full overflow-hidden transition-all duration-300 shadow-[0_0_30px_rgba(212,168,83,0.35)] hover:shadow-[0_0_50px_rgba(212,168,83,0.55)]" data-id="element-181">
            <span className="relative z-10 flex items-center gap-2" data-id="element-182">
              👉 QUIERO EMPEZAR AHORA
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-183" />
            </span>
            <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/25 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-184" />
          </motion.a>
          <p className="text-xs text-cream-muted/50" data-id="element-185">
            ✓ 7 días de garantía — si no te convence, te devolvemos el dinero
            sin preguntas.
          </p>
        </motion.div>
      </div>
    </section>;
}